import { render, staticRenderFns } from "./SolicitudesAnticipoModuloListado.vue?vue&type=template&id=24071f0c"
import script from "./SolicitudesAnticipoModuloListado.vue?vue&type=script&lang=js"
export * from "./SolicitudesAnticipoModuloListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports